import { render, staticRenderFns } from "./table-form-item.vue?vue&type=template&id=8dad7352&scoped=true&"
import script from "./table-form-item.vue?vue&type=script&lang=js&"
export * from "./table-form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dad7352",
  null
  
)

export default component.exports